(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  const track = document.querySelector('.promo-banner__track');
  const group = track ? track.querySelector('.promo-banner__group') : null;

  if (track && group) {
    // Keep a constant scroll speed (px per second) whatever the text length.
    const PROMO_SPEED = 50;
    const setPromoDuration = () => {
      track.style.setProperty('--promo-duration', (group.offsetWidth / PROMO_SPEED) + 's');
    };
    setPromoDuration();
    if (document.fonts) document.fonts.ready.then(setPromoDuration);
  }

  const toggle = document.querySelector('.site-header__mobile-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  const overlay = document.querySelector('.mobile-nav__overlay');
  const closeBtn = document.querySelector('.mobile-nav__close');

  function openNav() {
    mobileNav.classList.add('is-open');
    overlay.classList.add('is-visible');
    mobileNav.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    mobileNav.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    mobileNav.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', openNav);
  closeBtn.addEventListener('click', closeNav);
  overlay.addEventListener('click', closeNav);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeNav(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
document.addEventListener('click', function (event) {
  const button = event.target.closest('.quantity-stepper__btn');
  if (!button) return;

  const input = button.parentElement.querySelector('.quantity-stepper__input');
  const step = parseInt(button.dataset.step, 10);
  const newValue = Math.max(0, parseInt(input.value, 10) + step);
  input.value = newValue;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
(function() {
  const tabs = document.querySelectorAll('.product-tabs__tab');
  const panels = document.querySelectorAll('.product-tabs__panel');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
      panels.forEach(p => p.classList.remove('is-active'));
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      const target = document.getElementById('tab-panel-' + tab.dataset.tab);
      if (target) target.classList.add('is-active');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"]) return;
  try {
    
(function() {
  const form = document.getElementById('product-form');
  if (!form) return;

  const variantIdInput = document.getElementById('variant-id');
  const quantityInput = document.getElementById('quantity-input');
  const featuredImg = document.getElementById('product-featured-image');
  const quantityBtns = document.querySelectorAll('.product-hero__quantity-btn');
  const thumbBtns = Array.from(document.querySelectorAll('.product-hero__thumb'));
  const atcBtn = form.querySelector('.product-hero__atc');
  const prevBtn = document.querySelector('.product-hero__arrow--prev');
  const nextBtn = document.querySelector('.product-hero__arrow--next');
  const mainMedia = document.querySelector('.product-hero__main-media');
  const atcLabel = form.querySelector('.product-hero__atc-label');
  const ctaPrice = form.querySelector('[data-cta-price-target]');
  const ctaCompare = form.querySelector('[data-cta-compare-target]');
  const packageInputs = document.querySelectorAll('.pkg-card__input');

  const heroPrice = document.querySelector('[data-hero-price-target]');
  const heroCompare = document.querySelector('[data-hero-compare-target]');
  const heroSave = document.querySelector('[data-hero-save-target]');

  // The buy button shows the whole order: the chosen package plus every selected add-on.
  const money = new Intl.NumberFormat(atcBtn.dataset.moneyLocale, { style: 'currency', currency: atcBtn.dataset.moneyCurrency });
  let basePriceCents = Number(atcBtn.dataset.basePriceCents) || 0;
  let baseCompareCents = Number(atcBtn.dataset.baseCompareCents) || 0;
  let addonsTotalCents = 0;

  function renderCtaTotal() {
    if (ctaPrice) ctaPrice.textContent = money.format((basePriceCents + addonsTotalCents) / 100);
    if (!ctaCompare) return;
    ctaCompare.hidden = baseCompareCents <= 0;
    if (baseCompareCents > 0) ctaCompare.textContent = money.format((baseCompareCents + addonsTotalCents) / 100);
  }

  function updateCtaPrice(source) {
    basePriceCents = Number(source.dataset.ctaPriceCents) || 0;
    baseCompareCents = Number(source.dataset.ctaCompareCents) || 0;
    renderCtaTotal();
    if (heroPrice) heroPrice.textContent = source.dataset.ctaPrice;
    if (heroCompare) {
      heroCompare.textContent = source.dataset.ctaCompare;
      heroCompare.hidden = !source.dataset.ctaCompare;
    }
    if (heroSave) {
      const savePct = Number(source.dataset.ctaSave) || 0;
      heroSave.textContent = heroSave.dataset.saveTemplate.replace('[percent]', savePct);
      heroSave.hidden = savePct <= 0;
    }
  }

  packageInputs.forEach(input => {
    input.addEventListener('change', () => {
      packageInputs.forEach(i => i.closest('.pkg-card').classList.toggle('is-selected', i.checked));
      if (quantityInput) quantityInput.value = input.value;
      updateCtaPrice(input);
    });
  });

  let currentIndex = thumbBtns.findIndex(b => b.classList.contains('is-active'));
  if (currentIndex < 0) currentIndex = 0;

  // Scrolls only the thumbnail strip (never the page) so the active thumbnail is visible.
  function scrollThumbIntoView(thumb) {
    const strip = thumb.parentElement;
    const thumbEnd = thumb.offsetLeft + thumb.offsetWidth;
    if (thumb.offsetLeft < strip.scrollLeft) {
      strip.scrollLeft = thumb.offsetLeft;
    } else if (thumbEnd > strip.scrollLeft + strip.clientWidth) {
      strip.scrollLeft = thumbEnd - strip.clientWidth;
    }
  }

  function goToIndex(idx) {
    if (thumbBtns.length === 0) return;
    currentIndex = (idx + thumbBtns.length) % thumbBtns.length;
    thumbBtns.forEach((b, i) => b.classList.toggle('is-active', i === currentIndex));
    scrollThumbIntoView(thumbBtns[currentIndex]);
    if (featuredImg) {
      featuredImg.style.opacity = '0';
      featuredImg.srcset = '';
      featuredImg.src = thumbBtns[currentIndex].dataset.src;
      featuredImg.onload = () => { featuredImg.style.opacity = '1'; };
    }
  }

  thumbBtns.forEach((btn, idx) => btn.addEventListener('click', () => goToIndex(idx)));

  if (prevBtn) prevBtn.addEventListener('click', () => goToIndex(currentIndex - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => goToIndex(currentIndex + 1));

  if (mainMedia) {
    let touchStartX = 0;
    mainMedia.addEventListener('touchstart', e => { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
    mainMedia.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) goToIndex(diff > 0 ? currentIndex + 1 : currentIndex - 1);
    }, { passive: true });
  }

  quantityBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      quantityBtns.forEach(b => { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      if (quantityInput) quantityInput.value = btn.dataset.quantity;
      updateCtaPrice(btn);
    });
  });

  // Add-on quantity rows (one per variant): keep the add-on's switch and price in sync.
  function sumSelectedAddons() {
    let cents = 0;
    document.querySelectorAll('.hero-addon-input:checked').forEach(checkedInput => {
      checkedInput.closest('.hero-addons__item').querySelectorAll('[data-addon-row]').forEach(row => {
        cents += (parseInt(row.querySelector('[data-addon-quantity]').value) || 0) * Number(row.dataset.priceCents);
      });
    });
    return cents;
  }

  document.querySelectorAll('.hero-addons__item').forEach(item => {
    const input = item.querySelector('.hero-addon-input');
    const options = item.querySelector('[data-addon-options]');
    if (!input || !options) return;

    const rows = Array.from(options.querySelectorAll('[data-addon-row]'));
    const priceEl = item.querySelector('.hero-addons__price');
    const quantityOf = row => row.querySelector('[data-addon-quantity]');

    function syncAddon() {
      let totalQuantity = 0;
      let totalCents = 0;
      rows.forEach(row => {
        const field = quantityOf(row);
        const quantity = Math.min(Number(field.max), Math.max(0, parseInt(field.value) || 0));
        field.value = quantity;
        totalQuantity += quantity;
        totalCents += quantity * Number(row.dataset.priceCents);
      });
      // Nothing selected means the add-on is off; show the single-unit price again.
      if (totalQuantity === 0) {
        input.checked = false;
        options.hidden = true;
        totalCents = Number(options.dataset.priceCents);
      }
      if (priceEl) priceEl.textContent = money.format(totalCents / 100);
      addonsTotalCents = sumSelectedAddons();
      renderCtaTotal();
    }

    input.addEventListener('change', () => {
      options.hidden = !input.checked;
      rows.forEach(row => { quantityOf(row).value = 0; });
      if (input.checked) {
        const defaultRow = options.querySelector('[data-addon-default]') || rows[0];
        quantityOf(defaultRow).value = 1;
      }
      syncAddon();
    });

    rows.forEach(row => {
      quantityOf(row).addEventListener('change', syncAddon);
      row.querySelectorAll('[data-addon-step]').forEach(button => {
        button.addEventListener('click', () => {
          const field = quantityOf(row);
          field.value = (parseInt(field.value) || 0) + Number(button.dataset.addonStep);
          syncAddon();
        });
      });
    });
  });

  // Adds the items and returns Shopify's response (with the re-rendered cart drawer when there is one), or null on failure.
  async function addToCart(items, cartDrawer) {
    const payload = cartDrawer ? { items, sections: cartDrawer.sectionId } : { items };
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    return res.ok ? res.json() : null;
  }

  // One of each gift per order: skip gifts already in the cart so a second purchase is not charged for one.
  async function getMissingGiftItems(giftVariantIds, giftFor) {
    if (giftVariantIds.length === 0) return [];
    let cartVariantIds = [];
    try {
      const cart = await (await fetch('/cart.js')).json();
      cartVariantIds = cart.items.map(item => item.variant_id);
    } catch {}
    return giftVariantIds
      .filter(id => !cartVariantIds.includes(id))
      .map(id => ({ id, quantity: 1, properties: { _gift_for: giftFor } }));
  }

  form.addEventListener('submit', async (e) => {
    const checkedAddons = document.querySelectorAll('.hero-addon-input:checked');
    const giftVariantIds = Array.from(document.querySelectorAll('[data-free-gift-variant]'))
      .map(el => parseInt(el.dataset.freeGiftVariant))
      .filter(Boolean);
    const cartDrawer = window.NurveCartDrawer;
    // Without a drawer and with nothing extra to add, the plain form post to the cart page is enough.
    if (!cartDrawer && checkedAddons.length === 0 && giftVariantIds.length === 0) return;

    e.preventDefault();

    const variantId = parseInt(variantIdInput.value);
    const quantity = parseInt(quantityInput.value) || 1;
    const items = [{ id: variantId, quantity: quantity }];

    checkedAddons.forEach(input => {
      input.closest('.hero-addons__item').querySelectorAll('[data-addon-row]').forEach(row => {
        const quantity = parseInt(row.querySelector('[data-addon-quantity]').value) || 0;
        if (quantity > 0) items.push({ id: parseInt(row.dataset.variantId), quantity });
      });
    });

    const originalLabel = atcLabel.textContent;
    atcLabel.textContent = atcBtn.dataset.addingLabel;
    atcBtn.disabled = true;

    const giftFor = document.querySelector('[data-free-gift-for]')?.dataset.freeGiftFor;
    const giftItems = await getMissingGiftItems(giftVariantIds, giftFor);

    try {
      // A gift problem (e.g. it sold out) must never block the main purchase, so retry without gifts.
      const added = await addToCart(items.concat(giftItems), cartDrawer)
        || (giftItems.length > 0 && await addToCart(items, cartDrawer));
      if (!added) throw new Error();
      if (!cartDrawer) {
        window.location.href = '/cart';
        return;
      }
      cartDrawer.render(added.sections[cartDrawer.sectionId]);
      cartDrawer.open();
    } catch {
      // The drawer could not take the items: fall back to the cart page, which shows Shopify's own error if any.
      if (cartDrawer) window.location.href = '/cart';
    }
    atcLabel.textContent = originalLabel;
    atcBtn.disabled = false;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
// Clicking a review with a photo opens it in a dialog with the photo full size and the whole review.
(function () {
  function init(root) {
    root.querySelectorAll('[data-review-modal]').forEach(modal => {
      const section = modal.closest('.reviews');
      const image = modal.querySelector('[data-review-modal-image]');
      const body = modal.querySelector('[data-review-modal-body]');

      function open(card) {
        image.src = card.dataset.fullImage;
        image.alt = card.querySelector('.review-card__image')?.alt || '';
        body.innerHTML = card.querySelector('.review-card__body').innerHTML;
        modal.showModal();
      }

      section.querySelectorAll('[data-review-open]').forEach(card => {
        card.addEventListener('click', () => open(card));
        card.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            open(card);
          }
        });
      });

      modal.querySelector('[data-review-close]').addEventListener('click', () => modal.close());
      // A click on the backdrop lands on the dialog element itself.
      modal.addEventListener('click', event => { if (event.target === modal) modal.close(); });
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
